import React from 'react';
import { Redirect } from 'react-router';

export default function DataAnalyticsPage() {
  return (
    <Redirect to="/data-analytics/dashboard"/>
  );
}